export const STANDARD_REPO = 'STANDARD_REPO';
export const SINGLE_STANDARD_SERVICE = 'SINGLE_STANDARD_SERVICE';
export const STANDARD_SERVICE = 'STANDARD_SERVICE';
export const STANDARD_PUBLIC_SERVICE = 'STANDARD_PUBLIC_SERVICE';

export const CATALOG_SERVICE = 'CATALOG_SERVICE';
export const CATALOG_REPO = 'CATALOG_REPO';

export const STAGES_SERVICE = 'STAGES_SERVICE';
